<template>
  <div class="say-nice-form ui-panel">
    <h2 class="text-xl font-semibold mb-4">
      Say Something Nice
    </h2>
    <form
      class="say-nice-form__fields"
      @submit.prevent="submitMessage"
    >
      <input
        v-model="name"
        type="text"
        placeholder="Your Name"
        class="ui-input ui-input--md"
      >
      <textarea
        v-model="message"
        placeholder="Say something nice..."
        class="ui-textarea ui-textarea--md"
      />
      <button
        type="submit"
        class="ui-button ui-button--primary ui-button--md"
      >
        Submit
      </button>
    </form>
  </div>
</template>

<script>
//import api from "@/services/api";
import { addMessage } from "@/services/api";

export default {
  data() {
    return {
      name: "",
      message: "",
    };
  },
  methods: {
    async submitMessage() {
      if (!this.message.trim()) return;

      const payload = {
        //text: `${this.name || "Anonymous"}: ${this.message}`,
        name: this.name || "Anonymous",
        message: this.message,
      };

      try {
        await addMessage(payload);
        this.name = "";
        this.message = "";
        this.$emit("message-added");
      } catch (error) {
        console.error("Error submitting message:", error);
      }
    },
  },
};
</script>

<style scoped>
.say-nice-form__fields {
  display: grid;
  gap: 0.75rem;
}
</style>
